export const SlaLimits = Object.freeze({
    "URGENT":60,
    "MEDIUM":240
})
